<template>
    <div ref="container" class="w-20 h-20" />
</template>

<script setup lang="ts">
import lottie, { AnimationItem } from 'lottie-web';
import {
    onMounted, ref, onBeforeUnmount,
} from 'vue';
import animationData from '@/assets/imgs/spark-loader-lottie.json';

const container = ref<HTMLDivElement | null>(null);

const props = withDefaults(defineProps<{
    loop?: boolean;
}>(), {
    loop: true,
});

const HALFWAY_FRAMES = 35;
const anim = ref<AnimationItem | null>(null);
const domReady = ref<boolean>(false);

const onDomLoaded = (): void => {
    domReady.value = true;
    if (!anim.value) return;
    if (props.loop) {
        anim.value.play();
    } else {
        anim.value.setSpeed(0.5);
        anim.value.playSegments([0, HALFWAY_FRAMES], true);
    }
};

onMounted(() => {
    if (!container.value) return;
    anim.value = lottie.loadAnimation({
        container: container.value,
        renderer: 'svg',
        loop: props.loop,
        autoplay: false,
        animationData,
    });

    anim.value.addEventListener('DOMLoaded', onDomLoaded);
});

onBeforeUnmount(() => {
    if (anim.value) {
        if (domReady.value) {
            anim.value.removeEventListener('DOMLoaded', onDomLoaded);
        }
        anim.value.destroy();
        anim.value = null;
    }
});

</script>

<style lang="scss" scoped>
.w-20 { width: 80px; }
.h-20 { height: 80px; }
</style>
